const applicationPaths = ["/insights-hub"].map((basename) => ({
    pattern: new RegExp(`${basename}(/|$)`),
    basename,
}));

export function getApplicationBasename(): string {
    const { pathname } = window.location;
    const basename =
        applicationPaths.find(({ pattern }) => pattern.exec(pathname))
            ?.basename ?? "/";
    return pathname.substring(0, pathname.indexOf(basename) + basename.length);
}
